import type { ReactNode } from 'react';

import {
  row as rowClass,
  rowContent,
  rowDepth1,
  rowDepth2,
  rowDepth3,
  spaceBelow as spaceBelowClass,
} from './TranscriptRow.css';

export type RowSpace = 'message' | 'item' | 'group' | 'thought';

export const formatClock = (timestamp: string | undefined): string | undefined => {
  if (!timestamp) {
    return undefined;
  }
  const parsed = Date.parse(timestamp);
  return Number.isNaN(parsed)
    ? undefined
    : new Date(parsed).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

export const TranscriptRow: React.FC<{
  depth?: 0 | 1 | 2 | 3;

  treeLast?: boolean;

  treeTrunkParent?: boolean;

  spaceBelow?: RowSpace;
  className?: string;
  children: ReactNode;
}> = ({ depth = 0, treeLast = false, treeTrunkParent = false, spaceBelow, className, children }) => (
  <div
    className={[rowClass, spaceBelow ? spaceBelowClass[spaceBelow] : undefined, className].filter(Boolean).join(' ')}
  >
    <div
      className={[
        rowContent,
        depth === 1 ? rowDepth1 : undefined,
        depth === 2 ? rowDepth2 : undefined,
        depth === 3 ? rowDepth3 : undefined,
      ]
        .filter(Boolean)
        .join(' ')}
      data-tree-last={depth >= 2 ? treeLast : undefined}
      data-tree-trunk-parent={depth === 3 ? treeTrunkParent : undefined}
    >
      {children}
    </div>
  </div>
);
